"use client"
import { useEffect } from "react"
import { useRouter } from "next/navigation"
import { Box, CircularProgress, Typography } from "@mui/material"
import { useAuth } from "../contexts/AuthContext"

export default function HomePage() {
  const router = useRouter()
  const { user, loading } = useAuth()

  useEffect(() => {
    if (!loading) {
      if (user) {
        // User is authenticated, redirect to dashboard
        router.push("/dashboard")
      }
      else {
        router.push("/login")
      }
    }
  }, [user, loading, router])

  // Show loading spinner while checking authentication
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        gap: 2,
      }}
    >
      <CircularProgress size={40} />
      <Typography variant="body1" color="text.secondary">
        Loading...
      </Typography>
    </Box>
  )
}
